module.exports = __webpack_public_path__ + "static/media/24.eae48746.jpeg";